module.exports = __webpack_public_path__ + "static/media/Cookies.791ebca9.ttf";